export interface IProductCodeableConcept {
  productIconIdentifier: string;
  type: string;
  display: string;
  description: string;
  tenantId: number;
  language: string;
}
